import React from "react";
import "./Header.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Navigate, useLocation, useNavigate } from "react-router-dom";

// import Logo from "../../../assets/images/magic-health-logo.png";
// import Epicured_Logo from "../../../assets/images/Epicured_Logo.png";
import MonteNido_Logo from "../../../assets/images/MonteNido_Logo.svg";
import HealthrageousLogo from "../../../assets/images/HealthrageousLogo.png";

const Header = ({ intro, route }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogoClick = () => {
    if (location.pathname === "/landing" || location.pathname === "/") {
      return;
    }
    navigate(route);
  };

  return (
    <nav
      className="container-fluid mx-auto navbar navbar-expand-lg navbar-light bg-white header-container--size p-0 text-left"
      id="header"
    >
      <div className="row w-100 justify-content-between mx-4 my-1 ">
        <div className="col-1 ">
          <div
            onClick={handleLogoClick}
            style={{
              cursor:
                location.pathname === "/" || location.pathname === "/landing"
                  ? "default"
                  : "pointer",
              display: "inline-block",
            }}
          >
            <img src={MonteNido_Logo} width="122" height="34" alt="logo" />
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
